import { VwProdutosMaisConsumidosResponsavelService } from './VwProdutosMaisConsumidosResponsavelService';

export const vwProdutosMaisConsumidosResponsavel = new VwProdutosMaisConsumidosResponsavelService();
